import logger from '~/services/logger';
import type { Feed, FeedEntry, UIComponent } from '~/services/layout/index.ts';
import { PowerCell } from '../../power-cell/components/index.tsx';
import { getPluginConfig } from '~/utils/get-plugin-configuration.ts';
import manifest from '../config/manifest.ts';
import { getComponentMarginsOnMaxWidth } from '~/utils/styles.ts';
import type { StorageFeedsData } from '~/components/ui-component.tsx';
import type { UseIsLoggedInReturnType } from '~/hooks/use-is-logged-in.ts';

export default function HeroV2({
  uiComponent,
  feed,
  storageFeedsData,
  isLoggedInData,
}: {
  uiComponent: UIComponent;
  feed?: Feed;
  storageFeedsData: StorageFeedsData;
  isLoggedInData: UseIsLoggedInReturnType;
}): JSX.Element {
  const { styles, rules } = getPluginConfig<typeof manifest>(
    manifest,
    uiComponent
  );

  const selectable = !!rules.component_cells_selectable;

  try {
    const firstEntry: FeedEntry | undefined = feed?.entry?.[0];

    if (!firstEntry) return <></>;

    return (
      <section
        className={`component-${
          uiComponent.id
        } component-classes relative h-fit w-full overflow-hidden border-none ${getComponentMarginsOnMaxWidth(
          { styles }
        )} component-maximum-width`}
      >
        <PowerCell
          uiComponent={uiComponent}
          entry={firstEntry}
          selectable={selectable}
          storageFeedsData={storageFeedsData}
          isLoggedInData={isLoggedInData}
        />
      </section>
    );
  } catch (error: any) {
    logger.info(`Hero V2: ${error.message}`);
    return <></>;
  }
}
